export default __webpack_public_path__ + "static/media/coin-scene.6c737c92.svg";